import Typography from "@mui/material/Typography";
import React, { FC } from "react";
import { COLOR_GREY300 } from "shared/theme/colors";
import { StyledNoOptionContainer } from "./styled";

type Props = {
  loading: boolean;
  inputValue?: string;
  onClick: () => void;
};

const EmptyOptions: FC<Props> = (props) => {
  return (
    <StyledNoOptionContainer>
      <Typography
        variant="bodySMedium"
        data-testid={`new-tag-type-${props.inputValue}`}
        color={COLOR_GREY300}
      >
        No tag type found
      </Typography>
    </StyledNoOptionContainer>
  );
};

export default EmptyOptions;
